import { Box } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const ActionsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  margin: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: theme.spacing(2),
  alignSelf: 'stretch',
  alignItems: 'end',
  justifyContent: 'space-between',
  minWidth: 'fit-content',
}));
